
(function headerModuleDefinition() {

    angular.module('ui.Header', ['ui.Layout']);

})();